import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import PricingSection from '../../sections/auth/PricingSection/PricingSection';
import { useInitiateSubscription } from '../../APIs/Subscription/subscription';
import '../../views/bookingmanagement/components/AddBooking/NewBookingModal.css';
import './subscriptionWall.css';

export default function SubscriptionWall({ isInactive }) {
  const { initiateSubscription } = useInitiateSubscription();
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const el = document.querySelector('.pc-container');
    if (!el) return;
    el.classList.toggle('sw-content-blurred', isInactive);
    return () => el.classList.remove('sw-content-blurred');
  }, [isInactive]);

  if (!isInactive) return null;

  const handleSelectPlan = async ({ planId }) => {
    setError('');
    try {
      const res = await initiateSubscription({ plan_id: planId, source: 'renewal' });
      if (res?.checkout_url) {
        window.location.href = res.checkout_url;
      } else {
        setError(res?.message || 'Could not start checkout. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <>
      {/* A centred card on the module pages' own ground: a banner in the app's
          pop-up header look with the lock in a gold ring, the message, what a
          plan unlocks, and one clear action. */}
      <div className="sw-overlay">
        {/* One card, no header or footer: soft colour washes spread across
            it, a gold lock medallion at the top, the title, status, message,
            what a plan unlocks and the action. */}
        <div className="sw-card sw-card--spread" role="dialog" aria-modal="true" aria-labelledby="sw-title">
          <span className="sw-card__wash" aria-hidden="true" />

          <div className="sw-card__body">
            <span className="sw-card__medal" aria-hidden="true">
              <i className="ph ph-lock-key" />
            </span>
            <h4 className="sw-card__title" id="sw-title">
              Subscription Required
            </h4>
            <span className="sw-card__eyebrow">Plan inactive</span>
            <p className="sw-card__text">Activate a plan to unlock all features.</p>

            <ul className="sw-card__perks">
              <li>
                <i className="ph ph-calendar-check" />
                Bookings
              </li>
              <li>
                <i className="ph ph-cash-register" />
                POS
              </li>
              <li>
                <i className="ph ph-gift" />
                Gift cards
              </li>
              <li>
                <i className="ph ph-chart-line-up" />
                Reports
              </li>
            </ul>

            <Button className="sw-card__cta" onClick={() => setShowModal(true)}>
              <i className="ph ph-sparkle" />
              Choose a Plan
            </Button>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="nb-modal subscription-plans-modal"
        backdropClassName="nb-backdrop"
      >
        <div className="nb-head">
          <span className="nb-head__glow" aria-hidden="true" />
          <span className="nb-head__tile">
            <i className="ph ph-crown-simple" />
          </span>
          <div className="nb-head__text">
            <h5 className="nb-head__title">Subscription Plans</h5>
            <span className="nb-head__sub">Pick the plan that fits your business</span>
          </div>
          <button type="button" className="nb-head__close" aria-label="Close" onClick={() => setShowModal(false)}>
            <i className="ph ph-x" />
          </button>
        </div>
        <Modal.Body className="nb-body sw-plans-body">
          <PricingSection onSelectPlan={handleSelectPlan} renewMode error={error} onClearError={() => setError('')} />
        </Modal.Body>
      </Modal>
    </>
  );
}
